import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TeacherPayoutEligibilityVM } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const teacherRetrievePayoutRequestEligibility = createAsyncThunk<TeacherPayoutEligibilityVM, void, { extra: Partial<Dependencies> }>(
  "payouts/teacherRetrievePayoutRequestEligibility",
  async (_, { extra: { teacherRepository } }) => {
    return teacherRepository!.getPayoutEligibility();
  },
);

export const resetTeacherRetrievePayoutRequestEligibility = createAction("payouts/resetTeacherRetrievePayoutRequestEligibility");
